import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  CircularProgress,
  Tab,
  Tabs,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PeopleIcon from '@mui/icons-material/People';
import InfoIcon from '@mui/icons-material/Info';
import { FaChessKnight } from 'react-icons/fa';

import { getTournament } from '../../services/tournament.service';
import TournamentInfo from './TournamentInfo';
import TournamentPlayers from './TournamentPlayers';
import TournamentRounds from './TournamentRounds';



const TabPanel = ({ children, value, index }) => (
  <Box
    role="tabpanel"
    hidden={value !== index}
    sx={{ pt: 3 }}
  >
    {value === index && children}
  </Box>
);

const TournamentDetailPage = () => {
  const { torId } = useParams();
  const navigate = useNavigate();
  const [torneo, setTorneo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    const fetchTorneo = async () => {
      try {
        const data = await getTournament(torId);
        setTorneo(data);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTorneo();
  }, [torId]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress sx={{ color: '#7c8cf8' }} />
      </Box>
    );
  }



  return (
    <Box sx={{ px: { xs: 2, md: 4 }, py: 3, maxWidth: 1200, mx: 'auto' }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 3 }}>
        <Tooltip title="Volver a Torneos">
          <IconButton
            onClick={() => navigate('/tournaments')}
            sx={{
              color: '#9aa5b4',
              mt: 0.5,
              '&:hover': { color: '#7c8cf8', background: 'rgba(124,140,248,0.1)' },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>

        <Box sx={{ flex: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}>
            <EmojiEventsIcon sx={{ color: '#d8f87c', fontSize: 28 }} />
            <Typography
              variant="h4"
              sx={{ color: '#e2e8f0', fontWeight: 800, lineHeight: 1.2, fontSize: '1.7rem' }}
            >
              {torneo?.tor_nombre ?? 'Torneo'}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Tabs */}
      <Box sx={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <Tabs
          value={tabIndex}
          onChange={(_, v) => setTabIndex(v)}
          sx={{
            '& .MuiTab-root': {
              color: '#9aa5b4',
              fontWeight: 600,
              textTransform: 'none',
              fontSize: '0.95rem',
              gap: 1,
              '&.Mui-selected': { color: '#704631' },
            },
            '& .MuiTabs-indicator': { background: '#704631', height: 3, borderRadius: 2 },
          }}
        >
          <Tab icon={<InfoIcon fontSize="small" />} iconPosition="start" label="Datos del torneo" id="tab-0" />
          <Tab icon={<PeopleIcon fontSize="small" />} iconPosition="start" label="Jugadores" id="tab-1" />
          <Tab icon={<FaChessKnight size={16} />} iconPosition="start" label="Partidas por ronda" id="tab-2" />
        </Tabs>
      </Box>

      <TabPanel value={tabIndex} index={0}>
        <TournamentInfo torneo={torneo} />
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        <TournamentPlayers torId={torId} />
      </TabPanel>

      <TabPanel value={tabIndex} index={2}>
        <TournamentRounds torId={torId} />
      </TabPanel>
    </Box>
  );
};

export default TournamentDetailPage;
